import { useTheme } from '../theme'
/**
 * Bandeaux d'installation PWA (S36 — extraits de App.jsx, JSX inchange).
 * L'etat et les handlers viennent de `hooks/usePwaInstall.js` (prop `pwa`).
 */
export default function PwaInstallBanners({ pwa, page, showImmersive }) {
  const { isWeb3 } = useTheme()
  const {
    installPrompt, showInstallBanner, isStandalone, showIOSBanner,
    handleInstall, dismissInstall, dismissIOSBanner,
  } = pwa

  return (
    <>
      {/* Bandeau installation PWA (Android/Desktop) */}
      {showInstallBanner && installPrompt && !isStandalone && (
        <div className={`fixed bottom-20 left-3 right-3 z-[60] rounded-2xl border p-4 backdrop-blur-xl animate-fade-up ${
          isWeb3 ? 'bg-[#0a0a0f]/95 border-white/10' : 'bg-white/95 border-ink/10'
        }`} style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
          <div className="flex items-center gap-3">
            <img src="/icons/icon-96x96.png" alt="Lyannaj" className="w-12 h-12 rounded-xl flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-bold text-ink`}>Installer Lyannaj</p>
              <p className={`text-[11px] text-ink/60`}>Acces rapide depuis ton ecran d'accueil</p>
            </div>
          </div>
          <div className="flex gap-2 mt-3">
            <button onClick={dismissInstall} className={`flex-1 py-2 rounded-xl text-xs font-medium border ${
              isWeb3 ? 'border-white/10 text-white/60' : 'border-ink/10 text-ink/50'
            }`}>Plus tard</button>
            <button onClick={handleInstall} className="flex-1 py-2 rounded-xl text-xs font-semibold text-white"
              style={{ background: 'linear-gradient(135deg, rgb(var(--c-primary)), rgb(var(--c-primary-soft)))' }}>
              Installer
            </button>
          </div>
        </div>
      )}

      {/* Bandeau installation iOS */}
      {showIOSBanner && !isStandalone && page === 'marche' && !showImmersive && (
        <div className={`fixed bottom-20 left-3 right-3 z-[60] rounded-2xl border p-4 backdrop-blur-xl animate-fade-up ${
          isWeb3 ? 'bg-[#0a0a0f]/95 border-white/10' : 'bg-white/95 border-ink/10'
        }`} style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
          <div className="flex items-start gap-3">
            <img src="/icons/icon-96x96.png" alt="Lyannaj" className="w-12 h-12 rounded-xl flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-bold text-ink`}>Installer Lyannaj</p>
              <p className={`text-[11px] leading-relaxed mt-1 text-ink/60`}>
                Appuie sur <span className="inline-block mx-0.5">
                  <svg className="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                  </svg>
                </span> puis <strong>"Sur l'ecran d'accueil"</strong>
              </p>
            </div>
            <button onClick={dismissIOSBanner} className={`text-lg leading-none ${isWeb3 ? 'text-white/30' : 'text-ink/30'}`}>×</button>
          </div>
        </div>
      )}
    </>
  )
}
